import store from "@/store/index";
import { config } from "@/utils/configuration/config";
import UserRepoFirebase from "@/repositories/users/UserRepoFirebase";
import User from "@/model/User";
import router from "@/router/index";
import ShipService from "./ShipService";

class UserService {
  private static instance: UserService;
  private usersRepo: any;
  private users: Array<User>;
  private static loggedIn: boolean = false;
  private userUidToBeLoggedWhenCreated = "";

  private constructor() {
    //console.log("UserService - constructor");

    if (!config.app.useFirebase) {
      //console.log("No hay ningun StaticFirebase para Users.");
    } else {
      this.usersRepo = new UserRepoFirebase();
    }

    this.users = new Array<User>();
  }

  public static getInstance(): UserService {
    //console.log("UserService - getInstance");
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }

    return UserService.instance;
  }

  public async getUsers(users: Array<User>) {
    if (this.users.length == 0) {
      await this.usersRepo.getUsers(users, this);
      this.users = users;
    } else {
      this.users.forEach((user) => users.push(user));
    }
  }

  public getUser(userId: string): User | undefined {
    //console.log("Se quiere buscar el user con id", userId, "dentro de la lista de Users", this.users);
    return this.users.find((user) => user.id === userId);
  }

  public addNewUserFromRepo(users, id, data) {
    //console.log("UserService-addNewUserFromRepo. Añadido user", id, data.name);
    const user = this.getUserFromFirebase(id, data);
    users.push(user);

    // Si el uid coincide con el que se está esperando para hacer el login, se hace
    if (user.uid === this.userUidToBeLoggedWhenCreated) {

      //pongo "ECOBUQ" porque he modificado esta función para que detecte a través de parámetros a qué sección tiene que ir
      this.selectedUser(user, "ECOBUQ");
    }
  }

  public modifyUserFromRepo(users, id: string, data: any) {
    //console.log("UserService-modifyUserFromRepo. Modificado user", id, data);
    const pos = users.map((val) => val.id).indexOf(id);

    const newUserObj = this.getUserFromFirebase(id, data);

    users[pos] = newUserObj;

    if (id === store.getters.currentUser.id) {
      store.commit("SET_CURRENT_USER", newUserObj);
    }
  }

  public removeUserFromRepo(users: Array<User>, id: string) {
    const pos = users.map((val) => val.id).indexOf(id);
    if (pos >= 0) {
      users.splice(pos, 1);
    }
  }

  public selectedUser(user, section) {
    //console.log("Nuevo usuario establecido en la sesión", user);
    if (user == null) {
      store.commit("SET_CURRENT_USER", null);
    } else {
      this.users.forEach((val) => {
        if (val.uid == user.uid) {
          store.commit("SET_CURRENT_USER", val);
        }
      });
      
      //console.log("UserService 2: " + section)
      // Una vez establecido un usuario válido, y no antes, vamos a la página principal
      if(section === "ECOBUQ"){
        this.routerLoggingEcobuq();
      }else if( section === "NEOBUQ"){
        this.routerLoggingNeobuq()
      }

    }
  }

  private getUserFromFirebase(id, data) {
    const user = {
      id: id,
      uid: data.uid,
      firstName: data.firstName,
      lastName: data.lastName,
      sector: data.sector,
      company: data.company,
      charge: data.charge,
      email: data.email,
      administrator: data.administrator,
      dni: data.dni,
      cif: data.cif
    };
    //console.log("xx222  xxx", user);
    return user;
  }
  //Por ahora no habra name.
  private getUserToFirebase(user) {
    const result = {
      name: user.email ? user.email : undefined,
      administrator: false,
      uid: user.uid ? user.uid : undefined,
      firstName: user.firstName ? user.firstName : undefined,
      lastName: user.lastName ? user.lastName : undefined,
      sector: user.sector ? user.sector : undefined,
      company: user.company ? user.company : undefined,
      charge: user.charge ? user.charge : undefined,
      email: user.email ? user.email : undefined,
      dni : user.dni ? user.dni : " ",
      cif : user.cif ? user.cif : " "
    };
    return result;
  }

  public saveUser(user, state) {
    //console.log("UserService-saveUser", user);
    const userToFirebase = this.getUserToFirebase(user);

    //state nos indica si el usuario ya está creado o no
    if(state){
      return this.usersRepo.editUser(user.id, userToFirebase)
    }else{
      return this.usersRepo.saveNewUser(userToFirebase);
    }

    //router.push({ name: "logging" });
  }

  public deleteUser(userId) {
    this.usersRepo.deleteUser(userId);
  }

  // funcion para comprobar si estas loggeado, devuelve un boolean al componente.
  public logged() {
    if (UserService.loggedIn == true) {
      return true;
    } else {
      return false;
    }
  }

  public async signIn(signUp: boolean, data: Object, section: string) {
    //console.log("UserService: " + section)
    await signUp ? this.usersRepo.signin(UserService.instance, data, section) : this.usersRepo.createUser(UserService.instance, data);
  }
  
  public emailVerification(email: string) {
    //console.log("Verificando email", email, "dentro de la lista de Users", this.users);
    const verf = this.users.find((user) => user.email === email);
    //console.log("Verificando email", email, "dentro de la lista de Users", verf);

    // Si se ha encontrado algún usuario (vref != undefined) tenemos un error en el registro
    const errorInVerification = verf;
    return !errorInVerification;
  }

  public changeUserPassword(email2: string, password2: string, newPassword: string){

      //llamar al repositorio para que lo cambie
      //console.log("Cambiando contraseña...")
      const data = { email: email2, password: password2 }
      const result = this.usersRepo.changeUserPassword(UserService.instance, data, newPassword)
     // const result = 

     if(result){
      //console.log("Contraseña modificada con éxito!!")
      //router.push({ name: "logging" });

      //YA ESTAMOS EN LA PANTALLA DE LOGGING, SÓLO HAY QUE CAMBIAR EL FORMULARIO
      return true


     }else{
      //console.log("Error al cambiar la contraseña")
      return false
     }

  }
  public loggout() {
    this.usersRepo.loggout(UserService.instance);
    ShipService.getInstance().clearShips();
    router.push({ name: "logging" });
  }

  //función para irnos a la pantalla principal de ECOBUQ
  public routerLoggingEcobuq() {
    if (store.getters.currentUser != null) {
      router.push({ name: "home" });
    }
  }

  //función para irnos a la pantalla principal de ECOBUQ
  public routerLoggingNeobuq(){
    if (store.getters.currentUser != null) {
      router.push({ name: "neobuqHome" });
    }
  }

  public waitUserForSelectWhenCreated(userUid: string) {
    this.userUidToBeLoggedWhenCreated = userUid;
  }
}

export default UserService;
